module.exports = __webpack_public_path__ + "static/media/icon-20-emblem.16a4ca96.svg";